import { c as _c } from "react/compiler-runtime";
import { SkeletonBlock, TextBodySkeleton } from "@opensea/ui-kit";
import { ProfileMetadataChipsSkeleton } from "../ProfileMetadataChips/ProfileMetadataChipsSkeleton";
import { ProfilePreviewTooltipCollectionTableSkeleton } from "./CollectionTable/ProfilePreviewTooltipCollectionTableSkeleton";
import { ProfilePreviewTooltipLayout } from "./ProfilePreviewTooltipLayout";
export function ProfilePreviewTooltipContentSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProfilePreviewTooltipLayout avatar={<SkeletonBlock className="size-[46px] rounded-full" />} chips={<ProfileMetadataChipsSkeleton variant="default" />} collectionsTable={<ProfilePreviewTooltipCollectionTableSkeleton />} name={<TextBodySkeleton className="h-[18px] w-[150px]" size="sm" />} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}